module.exports = __webpack_public_path__ + "static/media/reportycms.1a4ba187.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/reportycms.png
// module id = 449
// module chunks = 0